import Cookies from "js-cookie";
import axios from "./config";
import { jwtDecode } from "jwt-decode";

interface DecodedToken {
  emp_id: string;
}

export function getHeader() {
  const token = Cookies.get("token") || "";
  const header = {
    Authorization: token,
  };
  return header;
}

const getUserInfo = () => {
  const token = Cookies.get("token");

  if (!token) {
    throw new Error("Authorization token not found");
  }

  return jwtDecode<DecodedToken>(token);
};
export const getSpecificPerm = async (
  id: string,
): Promise<any> => {

  let url = `admin/role-permissions/${id}`;
  const response = await axios.get<any>(url, {
    headers: getHeader(),
  });
  return response.data;
};
export const deleteRoles = async (id: number): Promise<any> => {
  let url = `/admin/roles/employee-mapping/${id}`;
  const response = await axios.delete<any>(url, {
    headers: getHeader(),
  });
  return response.data;
};
export const getAllAuth = async (
  page: number,
  size: number,
  params: any
): Promise<any> => {
  let url = "";
  if (params.search)
   url = `/admin/roles?page=${page}&size=${size}&search=${params.search}`;
 else url = `/admin/roles?page=${page}&size=${size}`;
  const response = await axios.post<any>(url, params, {
    headers: getHeader(),
  });
  return response.data;
};
export const updatePerm = async (
  formData: any,
  id: string
): Promise<any> => {

  const url = `/admin/role-permissions/${id}`;

  const cleanedPayload = Object.fromEntries(
    Object.entries(formData).filter(([_, v]) => v !== undefined)
  );
  

  const response = await axios.put(url, cleanedPayload, {
    headers: {
      ...getHeader(),
      "Content-Type": "application/json",
    },
  });
  return response.data;
};
export const getAllAuthEmployee = async (
  page: number,
  size: number,
  params: any
): Promise<any> => {
  let url = "";
  if (params.search)
   url = `/admin/roles/employee-mappings?page=${page}&size=${size}&search=${params.search}`;
 else url = `/admin/roles/employee-mappings?page=${page}&size=${size}`;
  const response = await axios.post<any>(url, params, {
    headers: getHeader(),
  });
  return response.data;
};

export const getAllAuthPerm = async (
  page: number,
  size: number,
  params: any
): Promise<any> => {
  const url = `/admin/role-permissions${params.search ? 's' : ''}`;

  const response = await axios.get(url, {
    headers: getHeader(),
    params: {
      page,
      size,
      search: params.search || undefined,
      ...params, // add other filters if needed
    },
  });

  return response.data;
};


export const getDropdownsales = async (
 
): Promise<any> => {
  let url = `admin/available-sales-offices`;
  const response = await axios.get<any>(url, {
    headers: getHeader(),
  });
  return response.data;
};

export const getDropdownchannel = async (
 
): Promise<any> => {
  let url = `admin/available-channels`;
  const response = await axios.get<any>(url, {
    headers: getHeader(),
  });
  return response.data;
};


export const getDropdownEmp = async (
 
): Promise<any> => {
  let url = `admin/available-employees`;
  const response = await axios.get<any>(url, {
    headers: getHeader(),
  });
  return response.data;
};

export const updateSales = async (
  formData: any,
  id: string
): Promise<any> => {
  const url = `/admin/sales-rules/${id}`;

  const cleanedPayload = Object.fromEntries(
    Object.entries(formData).filter(([_, v]) => v !== undefined)
  );
  

  const response = await axios.put(url, cleanedPayload, {
    headers: {
      ...getHeader(),
      "Content-Type": "application/json",
    },
  });
  return response.data;
};
export const addNewRules = async (formData: any): Promise<any> => {
  let url = `/admin/roles/create`;
  const response = await axios.post<any>(url, formData, {
    headers: getHeader(),
  });
  return response.data;
};
export const addNewPerm = async (formData: any): Promise<any> => {
  let url = `/admin/role-permissions/create`;
  const response = await axios.post<any>(url, formData, {
    headers: getHeader(),
  });
  return response.data;
};
export const addTarget = async (formData: any): Promise<any> => {
  let url = `/admin/roles/assign-employee`;
  const response = await axios.post<any>(url, formData, {
    headers: getHeader(),
  });
  return response.data;
};

// export const getAllSales = async (
//     page: number,
//     size: number,
//     params: any
//   ): Promise<any> => {
//     let url = "";
//     if (params.search)
//       url = `/admin/sales-rules?page=${page}&size=${size}&sales_office_ids=${params.search}`;
//     else url = `/admin/sales-rules?page=${page}&size=${size}`;
//     const response = await axios.post<any>(url, {
//       headers: getHeader(),
//     });
//     return response.data;
//   };
